import * as React from "react";
import type { SVGProps } from "react";
const MarineServices = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_7098)">
      <g clipPath="url(#clip1_4355_7098)">
        <path
          fill="currentColor"
          d="M9.0013 2.6673a1.332 1.332 0 0 1 1.3334-1.3333h5.3333c.7375 0 1.3333.5958 1.3333 1.3333v1.3334h2c1.1042 0 2 .8958 2 2v5.3333l1.85.6167c.9625.3208 1.2292 1.5625.4792 2.2458l-4.2083 3.8583c-.675.3917-1.4459.6292-2.1209.6292-.8166 0-1.7-.3208-2.4666-.8458a2.676 2.676 0 0 0-3.0709 0c-.7125.4916-1.5833.8458-2.4666.8458-.675 0-1.4459-.2375-2.1209-.6292L2.668 14.1965c-.75-.6875-.4833-1.925.4792-2.2458l1.8541-.6167V6.0007c0-1.1042.8959-2 2-2h2zM7.668 10.4465l4.4917-1.4959a2.658 2.658 0 0 1 1.6875 0l4.4875 1.4959V6.6673H7.668zm6.1042 8.4667c.9375.6458 2.0833 1.0875 3.2291 1.0875 1.1209 0 2.3084-.45 3.225-1.0875.4959-.3542 1.1709-.325 1.6334.0708.6.4958 1.3541.875 2.1083 1.05.7167.1667 1.1625.8833.9958 1.6-.1666.7167-.8833 1.1625-1.6.9958-1.0208-.2375-1.8708-.6875-2.425-1.0416-1.2083.65-2.5625 1.0791-3.9375 1.0791-1.3291 0-2.525-.4125-3.35-.7875-.2416-.1125-.4625-.2208-.65-.3208-.1875.1-.4041.2125-.65.3208-.825.375-2.0208.7875-3.35.7875-1.375 0-2.7291-.4291-3.9375-1.075-.5583.35-1.4041.8042-2.425 1.0417-.7166.1667-1.4333-.2792-1.6-.9958-.1666-.7167.2792-1.4334.9959-1.6.7541-.175 1.5083-.5542 2.1083-1.05.4625-.3917 1.1375-.4209 1.6333-.0709.9209.6334 2.1042 1.0834 3.225 1.0834 1.1459 0 2.2917-.4417 3.2292-1.0875a1.327 1.327 0 0 1 1.5417 0"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4355_7098">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="clip1_4355_7098">
        <path fill="transparent" d="M1 1.3335h24v21.3333H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default MarineServices;
